import type { ComponentType } from "react";
import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import { BankProductRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/BankProductRedesign";
import { BuildingSavingsRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/BuildingSavingsRedesign";
import { FundPortfolioSection } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/FundPortfolioSection";
import { LifeInsuranceRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/LifeInsuranceRedesign";
import { LoanAllRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/LoanAllRedesign";
import { PaidAdvisoryRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/PaidAdvisoryRedesign";
import { PensionProductRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/PensionProductRedesign";
import { PropertyInsuranceRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/PropertyInsuranceRedesign";
import { ServicesRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/ServicesRedesign";
import type { PortfolioDetailProps } from "web_myplann/Utils/types";

export const PORTFOLIO_SECTION_BY_DOMAIN: Partial<
	Record<ClientPortfolioDomainEnum, ComponentType<PortfolioDetailProps>>
> = {
	[ClientPortfolioDomainEnum.LifeInsurance]: LifeInsuranceRedesign,
	[ClientPortfolioDomainEnum.Investments]: FundPortfolioSection,
	[ClientPortfolioDomainEnum.Commodities]: FundPortfolioSection,
	[ClientPortfolioDomainEnum.Cryptocurrencies]: FundPortfolioSection,
	[ClientPortfolioDomainEnum.PropertyInsurance]: PropertyInsuranceRedesign,
	[ClientPortfolioDomainEnum.PensionProducts]: PensionProductRedesign,
	[ClientPortfolioDomainEnum.BuildingSavings]: BuildingSavingsRedesign,
	[ClientPortfolioDomainEnum.Loans]: LoanAllRedesign,
	[ClientPortfolioDomainEnum.Leasing]: LoanAllRedesign,
	[ClientPortfolioDomainEnum.BusinessLoans]: LoanAllRedesign,
	[ClientPortfolioDomainEnum.BankingProducts]: BankProductRedesign,
	[ClientPortfolioDomainEnum.Services]: ServicesRedesign,
	[ClientPortfolioDomainEnum.PaidAdvisory]: PaidAdvisoryRedesign,
};
